import {
    List,
    Create,
    Edit,
    SimpleForm,
    TextField,
    DateField,
    Resource,
    Show,
    ReferenceInput,
    ReferenceField,
    Filter,
    Datagrid,
    AutocompleteInput,
    SimpleShowLayout,
    SelectInput,
    useEditController
} from "react-admin";
import RawMaterialCategoryMaterialCategoryInput from "../components/RawMaterialCategoryMaterialCategoryInput";

const typeOptions = [
    { id: 'Finishing, type unknown', name: 'Finishing, type unknown' },
    { id: 'Unknown if finished', name: 'Unknown if finished' }
];

const Filters = (props) => (
    <Filter {...props}>
        <ReferenceInput alwaysOn label="Raw Material Category" source="rawMaterialCategoryId" reference="rawMaterialCategory" filterToQuery={searchText => ({ name: searchText })} >
            <AutocompleteInput optionText="name" />
        </ReferenceInput>

        <ReferenceInput alwaysOn label="Material Category" source="materialCategoryId" reference="materialsCategory" filterToQuery={searchText => ({ name: searchText })} >
            <AutocompleteInput optionText="name" />
        </ReferenceInput>

        <ReferenceInput alwaysOn label="Finishing" source="finishingId" reference="process/finishing" filterToQuery={searchText => ({ name: searchText })} >
            <AutocompleteInput optionText="name" />
        </ReferenceInput>

        <SelectInput source="type" label="Type" choices={typeOptions} />
    </Filter>
);

const DefaultMaterialFinishingList = (props) => {
    return (
        <List {...props} filters={Filters(props)}>
            <div style={{ marginTop: '15px' }}>
                <Datagrid rowClick="show">
                    <TextField source="id" />

                    <ReferenceField label="Raw Material Category" source="rawMaterialCategoryMaterialCategoryId" reference="rawMaterialCategoryMaterialCategory">
                        <TextField source="rawMaterialCategory.name" />
                    </ReferenceField>

                    <ReferenceField label="Material Category" source="rawMaterialCategoryMaterialCategoryId" reference="rawMaterialCategoryMaterialCategory">
                        <TextField source="materialCategory.name" />
                    </ReferenceField>

                    <ReferenceField label="Finishing" source="finishingId" reference="process/finishing">
                        <TextField source="name" />
                    </ReferenceField>

                    <TextField source="type" label="Type" />

                    <DateField source="createdAt" label="Creation date" />
                    <DateField source="updatedAt" label="Update date" />
                </Datagrid>
            </div>
        </List>
    );
};

const ShowDefaultMaterialFinishing = (props) => {
    return (
        <Show {...props}>
            <SimpleShowLayout>
                <TextField source="id" />

                <ReferenceField label="Raw Material Category" source="rawMaterialCategoryMaterialCategoryId" reference="rawMaterialCategoryMaterialCategory">
                    <TextField source="rawMaterialCategory.name" />
                </ReferenceField>

                <ReferenceField label="Material Category" source="rawMaterialCategoryMaterialCategoryId" reference="rawMaterialCategoryMaterialCategory">
                    <TextField source="materialCategory.name" />
                </ReferenceField>

                <ReferenceField label="Finishing" source="finishingId" reference="process/finishing">
                    <TextField source="name" />
                </ReferenceField>

                <TextField source="type" label="Type" />

                <DateField source="createdAt" label="Creation date" />
                <DateField source="updatedAt" label="Update date" />
            </SimpleShowLayout>
        </Show>
    );
};

const CreateDefaultMaterialFinishing = (props) => {
    return (
        <Create {...props}>
            <SimpleForm>
                <RawMaterialCategoryMaterialCategoryInput required />

                <ReferenceInput label="Finishing" source="finishingId" reference="process/finishing" filterToQuery={searchText => ({ name: searchText })}>
                    <AutocompleteInput optionText="name" required={true} />
                </ReferenceInput>

                <SelectInput source="type" label="Type" choices={typeOptions} required={true} />
            </SimpleForm>
        </Create>
    );
};

const EditDefaultMaterialFinishing = (props) => {
    const { record, isLoading } = useEditController(props);
    if (isLoading) return <div>Loading...</div>;
    return (
        <Edit {...props}>
            <SimpleForm>
                <RawMaterialCategoryMaterialCategoryInput record={record} required />

                <ReferenceInput label="Finishing" source="finishingId" reference="process/finishing" filterToQuery={searchText => ({ name: searchText })}>
                    <AutocompleteInput optionText="name" required={true} />
                </ReferenceInput>

                <SelectInput source="type" label="Type" choices={typeOptions} required={true} />
            </SimpleForm>
        </Edit>
    );
};

const defaultMaterialFinishingResource = () => <Resource
    name="defaultMaterialFinishing"
    options={{ label: 'Default Material Finishing', menuGroup: 'Bcome' }}
    list={DefaultMaterialFinishingList}
    create={CreateDefaultMaterialFinishing}
    edit={EditDefaultMaterialFinishing}
    show={ShowDefaultMaterialFinishing} />;

export default defaultMaterialFinishingResource;
